import moment from 'moment';
import { getCapacityInMinutesForADay } from 'components/organisms/user-capacity/utils';
import { isNonWorkingDay } from 'utils/working-days';
import { checkIfCurrentDateHasTimeOff } from './time-off-utils';
export const checkIfCurrentDateHasHoliday = (holidays, date = moment())=>{
    if (holidays == null || holidays.length === 0) {
        return undefined;
    }
    return holidays.find((holiday)=>date.isBetween(moment(holiday.holidayStart).startOf('day'), moment(holiday.holidayEnd).endOf('day'), undefined, '[]'));
};
export const getHolidayArray = (startDate, endDate, holidayArray)=>{
    if (startDate == null || endDate == null) {
        return undefined;
    }
    if (!holidayArray) {
        return undefined;
    }
    return holidayArray === null || holidayArray === void 0 ? void 0 : holidayArray.filter((holiday)=>moment(holiday.holidayStart).isBetween(startDate.startOf('day'), endDate.endOf('day'), undefined, '[]') || moment(holiday.holidayEnd).isBetween(startDate.startOf('day'), endDate.endOf('day'), undefined, '[]') || moment(startDate).isBetween(moment(holiday.holidayStart).startOf('day'), moment(holiday.holidayEnd).endOf('day'), undefined, '[]') || moment(endDate).isBetween(moment(holiday.holidayStart).startOf('day'), moment(holiday.holidayEnd).endOf('day'), undefined, '[]')).sort((a, b)=>{
        return moment.utc(a.holidayStart).diff(moment.utc(b.holidayEnd));
    });
};
export const checkIfHolidayInBetween = (range, holidaysValue)=>{
    if (range[0] !== null && range[1] !== null) {
        if (range[0] !== range[1]) {
            const holidayArray = getHolidayArray(moment(range[0]), moment(range[1]), holidaysValue) || [];
            if (holidayArray.length > 0) {
                return true;
            }
        }
    }
    return false;
};
export const getNoOfHolidayInBetween = (range, holidaysValue)=>{
    let holidayDaysCount = 0;
    if (range[0] !== null && range[1] !== null && holidaysValue) {
        if (range[0] !== range[1]) {
            const holidayArray = getHolidayArray(moment(range[0]), moment(range[1]), holidaysValue) || [];
            if (holidayArray.length > 0) {
                holidayArray.forEach((holiday)=>{
                    const startDate = moment(holiday.holidayStart, 'YYYY-MM-DD');
                    const endDate = moment(holiday.holidayEnd, 'YYYY-MM-DD');
                    holidayDaysCount += endDate.diff(startDate, 'days') + 1;
                });
            }
        }
    }
    return holidayDaysCount;
};
export const getNoOfDaysOfTimeOffAndHolidayInWeek = (startDate, noOfWorkingDaysInAWeek, userTimeOffDetails, holidays)=>{
    let noOfDays = 0;
    [
        ...Array(noOfWorkingDaysInAWeek)
    ].forEach((_, index)=>{
        const currentDay = startDate.add(index, 'day');
        let isHoliday;
        const isTimeOff = checkIfCurrentDateHasTimeOff(userTimeOffDetails, currentDay);
        if (!isTimeOff) {
            isHoliday = checkIfCurrentDateHasHoliday(holidays, currentDay);
        }
        noOfDays += isTimeOff || isHoliday ? 1 : 0;
    });
    return noOfDays;
};
export const getMinutesOfTimeOffAndHolidayInWeek = (startDate, user, workingDaysConfiguration, noOfWorkingDaysInAWeek, holidays, capacityMode)=>{
    let totalTimeOffHolidayMinutes = 0;
    let totalTimeOffMinutes = 0;
    let rawTotalTimeOffMinutes = 0;
    [
        ...Array(noOfWorkingDaysInAWeek)
    ].forEach((value, index)=>{
        const currentDay = startDate.clone().add(index, 'days');
        // Check if the current day is a non-working day or a holiday
        const isNonWorkingDayFlag = isNonWorkingDay(currentDay, workingDaysConfiguration);
        const isHoliday = checkIfCurrentDateHasHoliday(holidays, currentDay);
        const isTimeOff = checkIfCurrentDateHasTimeOff(user === null || user === void 0 ? void 0 : user.userTimeOffDetails, currentDay);
        const shouldCountHoliday = (capacityMode === null || capacityMode === void 0 ? void 0 : capacityMode.TOTAL_CAPACITY_MINUS_HOLIDAY) !== false;
        const shouldCountTimeOff = (capacityMode === null || capacityMode === void 0 ? void 0 : capacityMode.TOTAL_CAPACITY_MINUS_TIMEOFF) !== false;
        if (!isNonWorkingDayFlag && isHoliday && shouldCountHoliday) {
            // If it's a holiday, add the full daily capacity to holiday minutes
            totalTimeOffHolidayMinutes += getCapacityInMinutesForADay(user.capacityMinutes, workingDaysConfiguration);
        } else if (!isNonWorkingDayFlag && isTimeOff) {
            var _ref;
            const timeOffDuration = (_ref = isTimeOff === null || isTimeOff === void 0 ? void 0 : isTimeOff.timeOffDuration) !== null && _ref !== void 0 ? _ref : 0;
            rawTotalTimeOffMinutes += timeOffDuration;
            if (shouldCountTimeOff) {
                totalTimeOffMinutes += timeOffDuration;
                totalTimeOffHolidayMinutes += timeOffDuration;
            }
        }
    });
    return {
        totalTimeOffHolidayMinutes,
        totalTimeOffMinutes,
        rawTotalTimeOffMinutes
    };
};
